import { render, staticRenderFns } from "./SeaButtonsPage.vue?vue&type=template&id=39f9d704&scoped=true"
import script from "./SeaButtonsPage.vue?vue&type=script&lang=js"
export * from "./SeaButtonsPage.vue?vue&type=script&lang=js"
import style0 from "./SeaButtonsPage.vue?vue&type=style&index=0&id=39f9d704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9d704",
  null
  
)

export default component.exports